import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function ColorPicker({ className, disabled, label, color, colors, onChange }) {
  const [currentColor, setCurrentColor] = useState(undefined)

  const onColorPick = newColor => {
    if (newColor === currentColor) return
    setCurrentColor(newColor)
    onChange && onChange(newColor)
  }

  useEffect(() => {
    setCurrentColor(color)
  }, [color])

  return (
    <div
      className={clsx(className, 'hwd-header__controls', disabled && 'hwd-header__controls--disabled')}
      style={{ margin: 'unset' }} // This is a hack, since hwd-header__controls has a margin
    >
      <div className="hwd-header__colors">
        {label && <div className="hwd-header__label">{label}</div>}
        {colors.map(({ label, value }) => (
          <React.Fragment key={value}>
            <label className="hwd-header__color-tile">
              <input type="radio" value={value} checked={currentColor === value} onChange={() => onColorPick(value)} />
              <span className={`hwd-header__options-display ${value}`}></span>
              <span className="hwd-header__display-name">{label}</span>
            </label>
            &nbsp;
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

ColorPicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  onChange: PropTypes.func
}

ColorPicker.defaultProps = {
  disabled: false,
  colors: []
}
